// removed by extract-text-webpack-plugin
module.exports = {"category-detail":"category-detail","title-category":"title-category","wrap-category":"wrap-category","category-left-menu":"category-left-menu","category-menu":"category-menu","category-center-content":"category-center-content","category-right-search":"category-right-search","btn-viewmore-detail":"btn-viewmore-detail","btn-viewmore-text":"btn-viewmore-text"};


//////////////////
// WEBPACK FOOTER
// ./components/category-detail/style.scss
// module id = ./components/category-detail/style.scss
// module chunks = 0